<template>
  <div>
    <label
      class="font-bold dark:text-kanban-white text-kanban-medium-grey text-sm mb-2 inline-block"
      >Subtasks</label
    >
    <div
      v-for="(subtask, index) in subtasks"
      id="input-container"
      :key="index + 'subtask' + displayedTask.taskId"
      :class="['w-full', 'mb-3', 'rounded', 'flex', 'items-center']"
    >
      <input
        v-model="subtask.title"
        :class="[
          'input-element',
          'w-full',
          'py-2',
          'px-4',
          'rounded',
          'text-sm',
        ]"
        type="text"
        placeholder="e.g. Make Coffee"
      />
      <delete-button-vue
        class="ml-4"
        :index="index"
        @clicked="(pos) => deleteSub(pos)"
      />
      <span v-show="false" class="absolute right-4 top-2 text-kanban-red"
        >Invalid Value</span
      >
    </div>
    <action-button-vue :danger-button="false" class="mt-3" @click="addSub()">
      Add New SubTask
    </action-button-vue>
  </div>
</template>

<script>
import DeleteButtonVue from "./DeleteButton.vue";
import ActionButtonVue from "./ActionButton.vue";

import { mapState } from "vuex";

export default {
  name: "SubtasksInput",
  components: { DeleteButtonVue, ActionButtonVue },
  props: {
    initialSubtasks: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  emits: ["subtasks"],
  data() {
    return {
      subtasks: [],
      deleted: [],
    };
  },
  computed: {
    ...mapState({
      displayedTask: (state) => state.TasksModule.displayedTask,
    }),
  },
  watch: {
    subtasks: {
      handler: function () {
        this.emitValue();
      },
      deep: true,
    },
  },
  methods: {
    addSub() {
      this.subtasks.push({
        title: "",
        value: false,
      });
    },
    emitValue() {
      this.$emit("subtasks", this.subtasks);
    },
  },
};
</script>

<style scoped>
.input-element {
  background: none;
  @apply border dark:border-kanban-lines-dark border-kanban-lines-light;
}

.input-element:focus {
  outline: none;
}
</style>
